/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Stack, Typography } from "@mui/material";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap";
import { useAuth } from "cms/auth/hooks/use-auth";
import { useEffect, useState } from "react";
import { SimpliCityAdminSDK } from "@simplicitycms/simplicity-admin-js-sdk";
import { objectHasPropertyString, isGuid } from "utils/empty-exists";
import { ListImage } from "./image";
import { ListLink } from "./link";

const ImageListItemDisplay = (props) => {
    
    const { token } = useAuth();
    const { item } = props || {};
    const {
        heading,
        description,
        image: image_guid,
        link: link_guid,
    } = item || {};

    const [image, setImage] = useState();
    const [link, setLink] = useState();

    useEffect(() => {
        const fetch = async () => {
            if (!image) {
                if (image_guid && isGuid(image_guid)) {
                    const img = await SimpliCityAdminSDK.image.findOne(token, image_guid);
                    setImage(img);
                }
            }
        };
        fetch();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, image_guid]);
    
    useEffect(() => {
        const fetch = async () => {
            if (!link) {
                if (link_guid && isGuid(link_guid)) {
                    const _link = await SimpliCityAdminSDK.link.findOne(token, link_guid);
                    setLink(_link);
                }
            }
        };
        fetch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token, link_guid]);
    
    return (
        <div className='simplicity-image-list-item'>
            <Stack direction='row' justifyContent='flex-start'>
                <div className='simplicity-image-list-item-image'>
                    <ListImage image={image} />
                </div>
                <div className='simplicity-image-list-item-data'>
                    <Stack direction='column' justifyContent='flex-start'>
                        <div>
                            <Typography variant='h3' color={"text.primary"}>
                                {heading}
                            </Typography>
                        </div>
                        <div>
                            <RichTextPreview richtext={description} />
                        </div>
                        <div>
                            {objectHasPropertyString(link, "guid") &&
                                <ListLink
                                    link={link}
                                />
                            }
                        </div>
                    </Stack>
                </div>
            </Stack>
        </div>
    );
};

export { ImageListItemDisplay };
